import axios from 'axios';

import { Auth, PubSub } from 'aws-amplify';
import AWS from 'aws-sdk';

import { urlAsset, urlAction, URL_BASE } from '../constants/api_urls';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import moment from 'moment';
import amplifyconfig from '../aws-config';
import { store } from '../store';

var attached = false;

AWS.config.update({ region: 'eu-west-1' });

export const setAsset = payload => ({ type: 'GET_ALL_ASSETS', payload });
export const setConfigFile = payload => ({ type: 'SET_CONFIG_FILE', payload });
export const setTempConfigFile = payload => ({
  type: 'SET_TEMP_CONFIG_FILE',
  payload
});
export const setFilters = payload => ({ type: 'GET_FILTERS', payload });
export const setFilteredAssets = payload => ({
  type: 'GET_FILTERED_ASSETS',
  payload
});
export const setRoles = payload => ({ type: 'SET_ROLES', payload });
export const setUsers = payload => ({ type: 'GET_ALL_USERS', payload });
export const addUser = payload => ({ type: 'ADD_USER', payload });
export const disableUser = payload => ({ type: 'DISABLE_USER', payload });
export const editUserAttributes = payload => ({ type: 'EDIT_USER', payload });
export const resetState = () => ({ type: 'RESET_STATE' });
export const saveAuthentication = (payload) => ({ type: 'SET_AUTHENTICATION', payload });

export const attachPrincipalPolicy = async (jwtToken) => {
  const user = await Auth.currentUserInfo({
    bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  })
    .then(user => {
      var login = {};
      var loginKey = 'cognito-idp.' + AWS.config.region + '.amazonaws.com/' + amplifyconfig.userPoolId;
      login[loginKey] = jwtToken;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({

        IdentityPoolId: amplifyconfig.identityPoolId,
        Logins: login
      });

      new AWS.Iot().attachPolicy({ policyName: 'signeBlockIoTPolicy', target: user.id }, function (err, data) {
        if (err) {
          console.error(err); // an error occurred
        }
      });

      return user;
    })
    .catch(err => console.error(err));
  return user;
};

export const handleUserSession = async () => {
  const session = await Auth.currentSession({
    bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  })
    .then(session => {
      return session;
    })
    .catch(err => console.error(err));

  if (!attached) {
    // solo se debe a hacer una vez en la vida, pero la única forma de hacerlo es en front
    attachPrincipalPolicy(session.idToken.jwtToken);
    attached = true;
  }
  return session.idToken;
};

export const getAssets = (inputToken, from, to) => {
  return async dispatch => {
    const token = inputToken === undefined ? await handleUserSession() : inputToken;
    const myHeaders = new Headers({
      Authorization: 'Bearer ' + token.getJwtToken(),
      'X-Api-Key': token.decodePayload().apiKey
    });
    const init = {
      method: 'get',
      headers: myHeaders,
      mode: 'cors'
    };
    let pageSize = 1000;

    const configFile = localStorage.getItem('configFile');
    if (configFile) {
      const aux = JSON.parse(configFile).pageSize ?? 1000;
      if (aux) {
        pageSize = aux;
      }
    }
    let urlRequest = `${urlAsset}?pageSize=${pageSize}`;
    if (from && to) {
      const startDate = moment(from).format('YYYY-MM-DD');
      const endDate = moment(to).format('YYYY-MM-DD');
      urlRequest = `${urlRequest}&startDate=${startDate}&endDate=${endDate}`;
    }

    try {
      const allResults = [];
      let finish = false;
      let bookmark = '';
      while (!finish) {
        const myRequest = new Request(urlRequest + '&bookmark=' + bookmark, init);
        const response = await fetch(myRequest);
        const result = await response.json();
        allResults.push(...result.data);
        if (!result.bookmark || result.data.length < pageSize) {
          finish = true;
        } else {
          bookmark = result.bookmark;
        }
      }
      dispatch(setAsset(allResults));
      dispatch(executeFilters());
    } catch (err) {
      console.log(err);
      setAsset([]);
    }
  };
};

export const sendMessageNotification = async (message, role, user) => {
  var state = store.getState();
  var configFile = state.configFile;

  if (configFile) {
    var topic = configFile.name;

    if (role) {
      topic = topic + role;
    } else if (user) {
      topic = topic + user;
    }

    await PubSub.publish(topic, { type: 'NOTIFICATION', message });
  }
};

const contains = (target, pattern) => {
  return pattern && Array.isArray(pattern) && pattern.includes(target);
};

const includeText = (target, pattern) => {
  if (typeof target === 'string' && typeof pattern === 'string') {
    return target.toLowerCase().includes(pattern.toLowerCase());
  }
  return target === pattern;
};

export const executeFilters = () => {
  return async dispatch => {
    var state = store.getState();
    var filters = state.filters;
    var filteredAssets = [];
    var assets = state.assets;
    if (filters && assets) {
      filteredAssets = assets.filter(item => {
        const result = filters.filter(([key, value]) => {
          return value && Array.isArray(value)
            ? contains(item[key], value)
            : includeText(item[key], value);
        });
        return result.length === filters.length;
      });
    } else {
      filteredAssets = assets;
    }
    dispatch(setFilteredAssets(filteredAssets));
  };
};

export const getAssetHistory = async (tokenRol, id) => {
  const token = tokenRol === undefined ? await handleUserSession() : tokenRol;
  const myHeaders = new Headers({
    authorization: 'Bearer ' + token.getJwtToken(),
    'x-api-key': token.payload.apiKey
  });
  const init = {
    method: 'get',
    headers: myHeaders,
    mode: 'cors'
  };
  const myRequest = new Request(`${urlAsset}/history/${id}`, init);
  return fetch(myRequest, init)
    .then(response => response.json())
    .then(response => response.data)
    .catch(err => err);
};

let themePalette;

export const getConfigFile = (payload, tokenRol) => {
  return async dispatch => {
    const token = tokenRol === undefined ? await handleUserSession() : tokenRol;
    const myHeaders = new Headers({
      authorization: 'Bearer ' + token.getJwtToken(),
      'x-api-key': token.payload.apiKey
    });
    const init = {
      method: 'get',
      headers: myHeaders,
      mode: 'cors'
    };

    const myRequest = new Request(URL_BASE + '/config');

    return fetch(myRequest, init)
      .then(response => {
        return response.json();
      })
      .then(response => {
        localStorage.setItem('configFile', JSON.stringify(response.data));
        themePalette = response.data.theme;
        dispatch(setConfigFile(response.data));
      })
      .catch(err => console.error(err));
  };
};

export const postTempConfigFile = async config => {
  const token = await handleUserSession();

  config.lastUpdate = Date.now(); // add timestamp for last update

  const myHeaders = new Headers({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token.getJwtToken(),
    'X-Api-Key': token.decodePayload().apiKey
  });
  const request = await fetch(URL_BASE + '/config/temp', {
    method: 'post',
    headers: myHeaders,
    body: JSON.stringify(config)
  })
    .then(response => response.json())
    .catch(err => {
      console.error(err);
      return { message: 'FAIL' };
    });
  return request;
};

export const getTempConfigFile = (payload, tokenRol) => {
  return async dispatch => {
    const token = tokenRol === undefined ? await handleUserSession() : tokenRol;
    const headers = new Headers({
      authorization: 'Bearer ' + token.getJwtToken(),
      'x-api-key': token.payload.apiKey
    });
    const init = {
      method: 'get',
      headers,
      mode: 'cors'
    };
    const request = new Request(URL_BASE + '/config/temp');

    return fetch(request, init)
      .then(response => response.json())
      .then(response => dispatch(setTempConfigFile(response.data)))
      .catch(err => console.error(err));
  };
};

export const transactTempConfigFile = async () => {
  const token = await handleUserSession();

  const myHeaders = new Headers({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token.getJwtToken(),
    'X-Api-Key': token.decodePayload().apiKey
  });
  const request = await fetch(URL_BASE + '/config/temp/transact', {
    method: 'post',
    headers: myHeaders
  })
    .then(response => response.json())
    .catch(err => {
      console.error(err);
      return { message: 'FAIL' };
    });
  return request;
};

export const getTheme = () => {
  let theme = createMuiTheme(themePalette);
  theme = responsiveFontSizes(theme);
  return theme;
};

export const apiAction = async (actions, origin, destination) => {
  const token = await handleUserSession();
  const body = {
    source: origin,
    destination,
    actions
  };

  const myHeaders = new Headers({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token.getJwtToken(),
    'X-Api-Key': token.decodePayload().apiKey
  });
  const request = await fetch(urlAction, {
    method: 'post',
    headers: myHeaders,
    body: JSON.stringify(body)
  })
    .then(response => {
      return response.json();
    })
    .catch(err => {
      console.error(err);
      return [];
    }
    );
  return await request;
};

export const getUsers = (payload, tokenRol) => {
  return async dispatch => {
    const token = tokenRol === undefined ? await handleUserSession() : payload;
    const myHeaders = new Headers({
      Authorization: 'Bearer ' + token.getJwtToken(),
      'X-Api-Key': token.decodePayload().apiKey
    });
    const init = {
      method: 'get',
      headers: myHeaders,
      mode: 'cors'
    };
    const myRequest = new Request(`${URL_BASE}/user`, init);
    return fetch(myRequest)
      .then(response => {
        return response.json();
      })
      .then(response => {
        dispatch(setUsers(response.data));
      })
      .catch(err => err);
  };
};

export const saveNewTempConfigFile = async newConfigFile => {
  const token = await handleUserSession();
  axios
    .post(`${URL_BASE}/config/temp}`, newConfigFile, {
      headers: {
        Authorization: 'Bearer ' + token.getJwtToken(),
        'X-Api-Key': token.decodePayload().apiKey
      }
    })
    .then(resp => {
    })
    .catch(err => {
      console.error(err);
    });
};
